import { produccionApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
  getListByParentDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'PRODUCCION',
    api: produccionApi,
    relUrl: id,
  });
export const getByParent = (id) =>
  getObjectDataAction({
    dataName: 'PRODUCCION',
    api: produccionApi,
    relUrl: `indexByParent/${id}`,
  });

export const getAll = getListDataAction({
  dataName: 'PRODUCCION',
  api: produccionApi,
  relUrl: '',
});

export const getAllByParent = (id) =>
  getListByParentDataAction({
    dataName: 'PRODUCCION',
    api: produccionApi,
    relUrl: `indexByParent/${id}`,
  });

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'PRODUCCION',
    api: produccionApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'PRODUCCION',
    api: produccionApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'PRODUCCION',
  api: produccionApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'PRODUCCION',
    api: produccionApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('PRODUCCION');
export const setDeletedPending = createListDataDeletedPending('PRODUCCION');
